import { queryOptions, useQuery } from '@tanstack/react-query';

import { sharedApi } from '../../apis/shared.api';

interface ClauseCampaignsQueryOptions {
  enabled?: boolean;
}

export function clauseCampaignsQueryOptions(
  params: ClauseCampaignsQueryOptions = {},
) {
  return queryOptions({
    queryKey: ['clause-campaigns'],
    queryFn: () => sharedApi.clauseCampaigns(),
    enabled: params.enabled !== false,
  });
}

export function useClauseCampaigns() {
  return useQuery(clauseCampaignsQueryOptions());
}

export default useClauseCampaigns;
